import { Pagination, Page, PageWrapper } from './Carousel.components.styles';

import type { ControlProps } from './Carousel.components.d';

const CarouselPagination = ({ controls, state }: ControlProps) => {
  const { pageList, page } = state;
  const { scrollTo } = controls;

  return (
    <Pagination>
      {pageList.map((_, index) => {
        const item = index;

        return (
          <PageWrapper key={`dot-${item}`} data-index={index} onClick={scrollTo} role="button">
            <Page data-active={Number(page) === index} data-testid="dot" />
          </PageWrapper>
        );
      })}
    </Pagination>
  );
};

export default CarouselPagination;
